import { HorizontalLayout } from "../components/layout";

export function ActionBar({title, actionButton, filterButtons}){
    return(
        <HorizontalLayout className="actionbar space-between standard-margin-bottom">
          <HorizontalLayout>
            <h5 className="screen-title">{title}</h5>
            {actionButton}
          </HorizontalLayout>
          {filterButtons}
        </HorizontalLayout>
    )
}